export default "__VITE_ASSET__655650d0__"